import React from 'react';
import PropTypes from 'prop-types';
import socket from 'helpers/socket.io';
import { toArray } from 'helpers/parser';
import { log } from 'helpers/debug';

const { NODE_ENV } = process.env;

export const WebSocketContext = React.createContext();

export const WebSocketProvider = ({ children }) => {
  const subscribe = (eventName, callback) => {
    log('Subscribing to event:', eventName, { callback });
    const events = toArray(eventName);

    for (const event of events) {
      socket.on(event, callback);
    }
  };

  const unsubscribe = (eventName, callback) => {
    log('Unsubscribing to event:', eventName, { callback });
    const events = toArray(eventName);

    for (const event of events) {
      socket.off(event, callback);
    }
  };

  React.useEffect(() => {
    if (NODE_ENV !== 'development') return;

    const eventHandler = (event, data) => {
      log(`Socket: New event received "${event}"`, { data });
    };
    socket.onAny(eventHandler);

    return () => socket.offAny(eventHandler);
  }, []);

  return (
    <WebSocketContext.Provider value={{ subscribe, unsubscribe }}>
      {children}
    </WebSocketContext.Provider>
  );
};

WebSocketProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
